import { render, staticRenderFns } from "./addressTable.vue?vue&type=template&id=60b67bd4&scoped=true&"
import script from "./addressTable.vue?vue&type=script&lang=js&"
export * from "./addressTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60b67bd4",
  null
  
)

export default component.exports